module.exports = __webpack_public_path__ + "static/media/landingTile2.8dddf1e2.png";